import React, { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { toast } from 'react-toastify'
import parse from 'html-react-parser'
import moment from 'moment'
import { RootState } from 'redux/reducers/rootReducer'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'

import { TError } from 'config/types'
import { getAppIdCookie } from 'utils/token'

import './NewsItem.scss'

import CustomImage from 'components/custom-image/CustomImage'
import Preloader from 'components/preloader/Preloader'

// eslint-disable-next-line max-len
import { fetchOnePieceOfNewsAction } from 'containers/dashboard/features/news/store/actions'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

type PageParams = {
    id: string
}

const NewsItem = (): React.ReactElement => {
    const { t, i18n } = useTranslation(['toast'])
    const dispatch = useDispatch()

    const appId = getAppIdCookie()

    const { id } = useParams<PageParams>()
    const { article } = useSelector((state: RootState) => state.news)

    useEffect(() => {
        if (!appId) return
        if (!id) return
        dispatch(
            fetchOnePieceOfNewsAction({
                newsId: id,
                appId,
                callback: (type: string, errorArray?: TError[]) => {
                    if (type === 'error') {
                        errorArray?.forEach(err => {
                            console.error(err.description)
                            toast.error(t('toast:backendError'))
                        })
                    }
                },
            }),
        )
    }, [appId, dispatch, id, t, i18n.language])

    return (
        <>
            {article ? (
                <div className='m-blog-item'>
                    {article.imageUrl ||
                    (!!article.images && article.images?.length < 2) ? (
                        <CustomImage
                            src={
                                article.imageUrl ||
                                (article?.images?.length
                                    ? article.images[0]
                                    : '')
                            }
                        />
                    ) : (
                        <Swiper
                            className='m-blog-item_slider'
                            spaceBetween={0}
                            slidesPerView={1}
                            modules={[Pagination]}
                            pagination={{ clickable: true }}
                        >
                            {article.images?.map(image => (
                                <SwiperSlide key={image}>
                                    <CustomImage src={image} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    )}

                    <div className='m-blog-item__info new-loader--surface'>
                        <div className='m-blog-item__title new-loader--text'>
                            {article.title}
                        </div>
                        <div className='m-blog-item__date new-loader--text'>
                            {article.publicationDate
                                ? moment(article.publicationDate).format(
                                      'DD/MM/yyyy',
                                  )
                                : moment(Date.now()).format('DD/MM/yyyy')}
                        </div>
                        <div className='m-blog-item__desc new-loader--text'>
                            {article.description
                                ? parse(article.description)
                                : null}
                        </div>
                    </div>
                </div>
            ) : (
                <Preloader />
            )}
        </>
    )
}

export default NewsItem
